import React, { useEffect, useRef } from 'react';
import styles from './index.module.scss';
import round from './round.svg';

const LoadingSpinner = ({
  text = '',
  loading = false,
  children = null,
  size = 'default', // 'small', 'default', 'large'
  tip = '', // 提示文字，优先级高于text
  className,
  borderRadius = 0,
  maskStyle,
  ...props
}) => {
  const spinner = useRef();
  const container = useRef();
  useEffect(() => {
    if (container.current && container.current.style) {
      const width = spinner.current.clientWidth;
      const height = spinner.current.clientHeight;
      container.current.style.left =
        width / 2 - container.current.clientWidth / 2 + 'px';
      container.current.style.top =
        height / 2 - container.current.clientHeight / 2 + 'px';
    }
  }, [loading]);

  // 如果有children,增加loading覆盖层
  if (children) {
    return (
      <div ref={spinner} {...props} className={`${styles['box']} ${className}`}>
        {loading && (
          <div
            className={styles['icon-backdrop']}
            style={{ borderRadius, ...maskStyle }}
          >
            <div ref={container} className={styles['loading-container']}>
              <img
                src={round}
                className={`${styles['loading-spinner']} ${styles[`spinner-${size}`]}`}
                alt=""
              />

              <div className={styles['loading-dots']}>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
              </div>
              {(tip || text) && (
                <div className={styles['loading-text']}>{tip || text}</div>
              )}
            </div>
          </div>
        )}
        {children}
      </div>
    );
  }

  return (
    <div ref={spinner} className={styles['loading-overlay']}>
      <div ref={container} className={styles['loading-container']}>
        <img
          src={round}
          className={`${styles['loading-spinner']} ${styles[`spinner-${size}`]}`}
          alt=""
        />
        <div className={styles['loading-dots']}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
        {(tip || text) && (
          <div className={styles['loading-text']}>{tip || text}</div>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
